import type { LoadMessages } from '@cld/intl';
export { messages } from './messages';
import type {} from '@formatjs/icu-messageformat-parser';

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const loadLocaleJson = () => require?.context('./', false, /\.json$/);
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export const loadMessages = (locale: string) => loadLocaleJson()(locale) as ReturnType<LoadMessages>;
